import React, { useState, useEffect } from 'react';
import DeskNavbar from './DeskNavbar';
import MobileNavbar from './MobileNavbar';

function ResponsiveNavbar(props) {
  const [isMobile, setIsMobile] = useState(typeof window !== 'undefined' ? window.innerWidth < 992 : false);

  useEffect(() => {
    const handleResize = () => {
      if (typeof window !== 'undefined') {
        setIsMobile(window.innerWidth < 992);
      }
    };

    if (typeof window !== 'undefined') {
      window.addEventListener('resize', handleResize);
    }
    
    return () => {
      if (typeof window !== 'undefined') {
        window.removeEventListener('resize', handleResize);
      }
    };
  }, []);

  return (
    <>
      {isMobile ? (
        <MobileNavbar auth={props.auth} userDetails={props.userDetails} />
      ) : (
        <DeskNavbar auth={props.auth} userDetails={props.userDetails} />
      )}
    </>
  );
}

export default ResponsiveNavbar; 